export default __webpack_public_path__ + "static/criminal-background-checks-665b8afbedaffd2157e09d918dd12759.gif";